/* ============================================================================
   facil. — INTRO ANIMÉE « facil. » (loader signature). Vanilla, zéro lib.
   Ne s'exécute QUE si <html class="facil-intro-on"> (posé par le script de
   décision en <head> : 1re visite de session, motion OK, hors customizer).
   Séquence : lettres une par une → point (pop) → tenue → l'overlay se lève.
   Skip : clic / touche / scroll. Départ gaté sur le chargement d'Archivo Black
   (anti flash de police). transform/opacity uniquement (GPU, zéro reflow).
   ============================================================================ */
(function () {
  'use strict';

  var html = document.documentElement;
  if (!html.classList.contains('facil-intro-on')) return;

  var overlay = document.querySelector('.facil-intro');
  if (!overlay) { html.classList.remove('facil-intro-on'); return; }

  var started = false;
  var done = false;
  var autoTimer = null;

  function cleanupListeners() {
    window.removeEventListener('click', onSkip);
    window.removeEventListener('keydown', onSkip);
    window.removeEventListener('wheel', onSkip);
    window.removeEventListener('touchstart', onSkip);
  }

  function removeOverlay() {
    if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    html.classList.remove('facil-intro-on');
  }

  function finish() {
    if (done) return;
    done = true;
    if (autoTimer) clearTimeout(autoTimer);
    cleanupListeners();
    /* Le site « se pose » (léger dézoom + fondu) pendant que le voile se dissout. */
    html.classList.add('facil-intro-reveal');
    overlay.classList.add('is-leaving');
    var removed = false;
    var doRemove = function () { if (removed) return; removed = true; removeOverlay(); };
    overlay.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'opacity') doRemove();
    });
    setTimeout(doRemove, 900); /* repli si transitionend manque (fondu 0,7s) */
    /* Retrait de la classe de settle après l'anim du site (0,9s) → aucune coupe. */
    setTimeout(function () { html.classList.remove('facil-intro-reveal'); }, 1100);
  }

  function onSkip() { finish(); }

  function play() {
    if (started || done) return;
    started = true;
    /* Déclenche la révélation (lettres + point) au frame suivant. */
    requestAnimationFrame(function () { overlay.classList.add('is-playing'); });
    /* Levée de l'overlay après lettres (fin ~1,6s) + point (fin ~1,6s) + courte tenue. */
    autoTimer = setTimeout(finish, 1950);
  }

  window.addEventListener('click', onSkip);
  window.addEventListener('keydown', onSkip);
  window.addEventListener('wheel', onSkip, { passive: true });
  window.addEventListener('touchstart', onSkip, { passive: true });

  /* Démarrage gaté sur Archivo Black (repli 500 ms si l'API Font Loading manque/tarde). */
  function start() { play(); }
  if (document.fonts && document.fonts.load) {
    var to = setTimeout(start, 500);
    document.fonts.load('1em "Archivo Black"').then(
      function () { clearTimeout(to); start(); },
      function () { clearTimeout(to); start(); }
    );
  } else {
    start();
  }
})();
